import Container from "../common/Container";
import SectionTitle from "../common/SectionTitle";
import { testimonials } from "../../data/siteData";
import { FaQuoteLeft, FaStar } from "react-icons/fa6";
import "../../styles/Testimonials.css";

export default function Testimonials() {
  // We duplicate the array to ensure the scroll is seamless and infinite
  const duplicatedTestimonials = [...testimonials, ...testimonials];

  return (
    <section id="testimonials" className="testimonials-section">
      <Container>
        <SectionTitle
          badge="Client Feedback"
          title="What Our Clients Say"
          desc="Trusted by homeowners and facility managers across Australia."
        />
      </Container>

      <div className="testimonial-scroller-container">
        <div className="testimonial-track">
          {duplicatedTestimonials.map((t, index) => (
            <div key={index} className="testimonial-card frosted-glass">
              <div className="card-top">
                <div className="stars">
                  {[...Array(5)].map((_, i) => (
                    <FaStar key={i} className="star-icon" />
                  ))}
                </div>
                <FaQuoteLeft className="quote-icon-accent" />
              </div>
              
              <p className="testimonial-quote">"{t.quote}"</p>
              
              <div className="testimonial-footer">
                <div className="user-info">
                  <div className="user-avatar">{t.name.charAt(0)}</div>
                  <div>
                    <div className="user-name">{t.name}</div>
                    <div className="user-role">{t.role}</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}